import _ from "lodash";
import moment from "moment-timezone";

import { DisplayRangeType } from "./getDisplayRange";

type ListShape = Array<{date: Date} & Record<string, any>>;

/**
 * Helper function to group objects by display range
 * Ensures when grouping, the first date data point is the beginning of the relevant week / month / year
 *
 * @param list can be any list of objects as long as date exists
 * @param displayRange DisplayRangeType
 *
 * @example
 *
 * **In:**
 * ```
 * const list = [
 *   {date: "2021-01-01", value: 1},
 *   {date: "2021-01-02", value: 2},
 *   {date: "2021-01-03", value: 1},
 *   {date: "2021-02-01", value: 1},
 * ]
 * ```
 *
 * **Out:**
 * ```
 * {
 *    "2021-01-01": [
 *       {date: "2021-01-01", value: 1},
 *       {date: "2021-01-02", value: 2},
 *       {date: "2021-01-03", value: 1}
 *     ],
 *    "2021-02-01": [ {date: "2021-02-01", value: 1} ]
 * }
 * ```
 */
export const groupByDisplayRange = (list: ListShape, displayRange: DisplayRangeType): Record<string, ListShape> => {
  const minDate = moment.min(list.map(item => moment(item.date))).format("YYYY-MM-DD");

  return _.groupBy(list, dataPoint => {
    const startOfPeriod = moment.utc(dataPoint.date, "YYYY-MM-DD").startOf(displayRange);

    if (moment.utc(startOfPeriod).isBefore(minDate, "day")) {
      return minDate;
    }

    return startOfPeriod.format("YYYY-MM-DD");
  });
};